import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withTranslation } from 'utils/with-i18next';
import Head from 'next/head';

import Loading from 'components/Common/Loading';
import Layout from 'components/Layout';
import PageComponent from 'pages/PageComponent';
import NotificationActions from 'redux/NotificationActions';
import UserActions from 'redux/UserActions';

import ArcadeSection from './ArcadeSection';
import HeroSection from './HeroSection';
import PartnerSection from './PartnerSection';
import ShowcaseSection from './ShowcaseSection';
// import TestimonialsSection from './TestimonialsSection';
import TutorialSection from './TutorialSection';
import UseCasesSection from './UseCasesSection';

class HomeView extends PageComponent {
  constructor() {
    super();
    this.state = {
      now: new Date().getHours(),
      loading: false,
      nhr: false,
      heroHeight: 0,
    };
  }

  componentDidMount() {
    super.componentDidMount();
    const { now } = this.state;
    if (now >= 6 && now < 20) {
      this.setState({ nhr: true });
    }
    this.setupVideoScrollHandler();
  }

  componentDidUpdate() {
    window.addEventListener('scroll', this.onScroll);
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.onScroll);
  }

  setupVideoScrollHandler() {
    const threshold = window.innerWidth > 650 ? 1800 : 850;
    window.addEventListener('scroll', () => {
      const target = document.getElementsByClassName('step');
      const scrollY = window.scrollY;
      for (const element of target) {
        if (scrollY >= element.offsetTop - threshold) {
          const video = element.childNodes[0];
          const playPromise = video?.play();
          if (playPromise) playPromise.catch(() => {});
        }
      }
    });
  }

  onScroll = e => {
    const scrollTop = e.srcElement?.scrollingElement?.scrollTop || 0;
    const { now, heroHeight } = this.state;
    if (heroHeight < scrollTop) {
      this.setState({ nhr: false });
    } else if (heroHeight >= scrollTop && now >= 6 && now < 20) {
      this.setState({ nhr: true });
    }
  };

  handleHeroHeightChange = height => {
    this.setState({ heroHeight: height });
  };

  handleNhrChange = nhr => {
    this.setState({ nhr });
  };

  render() {
    const { loading } = this.state;

    return (
      <>
        <Head>
          <title>BGMs - Background Music Service</title>
          <meta name="description" content="BGMs provides background music streaming service for your channel" />
        </Head>
        <Layout>
          {loading ? (
            <Loading />
          ) : (
            <div className="index">
              <HeroSection onHeightChange={this.handleHeroHeightChange} onNhrChange={this.handleNhrChange} />
              <ArcadeSection />
              <TutorialSection />
              <UseCasesSection />
              {/* <TestimonialsSection /> */}
              <PartnerSection />
              <ShowcaseSection />
            </div>
          )}
        </Layout>
      </>
    );
  }
}

HomeView.propTypes = {
  UserRedux: PropTypes.object,
  NotificationRedux: PropTypes.object,
  t: PropTypes.func,
};

export default connect(
  state => state,
  (dispatch, ownProps) => ({
    ...UserActions(dispatch, ownProps),
    ...NotificationActions(dispatch, ownProps),
  })
)(withTranslation('index')(HomeView));
